import { Message } from "../../types/types";
import { useRef, useState } from "react";
import styles from "./PromotionalMessageItem.module.scss";
import { PromotionalCountdownTimer } from "./PromotionalCountdownTimer/PromotionalCountdownTimer";

type Props = {
  message: Message;
  countdownTimerVariant: string;
  countdownTimerAvailabileToOrder: boolean;
};

export const PromotionalMessageItem = ({
  message,
  countdownTimerVariant,
  countdownTimerAvailabileToOrder,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoButtonRef = useRef<HTMLButtonElement>(null);

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);

  return (
    <>
      <div className={styles.promoMessageContainer}>
        <div className={styles.messageContainer}>
          <p className={styles.message}>{message.title}</p>
          {message.description ? (
            <button
              data-testid="product:delivery-service:tooltip:button:expand"
              ref={infoButtonRef}
              onClick={handleTooltipExpandClick}
              className={styles.promoToolTip}
              aria-label={`${message.title} information`}
            >
              {" "}
            </button>
          ) : null}
        </div>
        {countdownTimerVariant?.length > 0 &&
          countdownTimerVariant !== "Control" && (
            <PromotionalCountdownTimer
              message={message.title}
              availableToOrder={countdownTimerAvailabileToOrder}
              countdownTimerVariant={countdownTimerVariant}
            />
          )}
      </div>
      <div
        data-testid="product:promotional-message:tooltip"
        className={showInfo ? styles.infoBlock : styles.infoBlockHide}
      >
        <button
          aria-label="Collapse tooltip"
          data-testid="product:promotional-message:tooltip:button:collapse"
          onClick={handleTooltipCollapseClick}
          className={styles.closeButton}
        />
        <div aria-live="polite" className={styles.tip}>
          <div dangerouslySetInnerHTML={{ __html: `${message.description}` }} />
        </div>
      </div>
    </>
  );
};
